module.exports = __webpack_public_path__ + "img/build.1ce21d2c.svg";